<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">State of Michigan</p>
        <h1 class="dg-header">Page Templates</h1>
        <p>Examples of basic pages using the Digital Guidelines.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">Basic Template</p>
            <img class="card-img-top box-shadow" src="static/page-templates/basic/screenshot.jpg" alt="Basic Template">
            <a class="btn btn-primary mt-4" href="./static/page-templates/basic/index.html">Demo</a>
          </div>
        </div>
        <!-- Content End -->
      </div>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "PageTemplates"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
.box-shadow {
  -webkit-box-shadow: 2px 2px 15px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 15px 0px rgba(0,0,0,0.75);
  box-shadow: 2px 2px 15px 0px rgba(0,0,0,0.75);
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/PageTemplates.vue